import { render, staticRenderFns } from "./tuihuo.vue?vue&type=template&id=b68e68fe&scoped=true"
import script from "./tuihuo.vue?vue&type=script&lang=js"
export * from "./tuihuo.vue?vue&type=script&lang=js"
import style0 from "./tuihuo.vue?vue&type=style&index=0&id=b68e68fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68e68fe",
  null
  
)

export default component.exports